import React from 'react';

import Plus from '@src/assets/svg/add-member-icon.inline.svg';
import { IUserStore } from '@src/models/UserStore';
import { ROUTES } from 'src/constants';
import { StyledButton, Link, Box } from 'src/kit';
import { Tooltip } from '@src/features/common/molecules';

export type CompanyActionsProps = {
  user: IUserStore['user'];
  isUserActive: boolean;
};

export const CompanyActions = ({ user, isUserActive }: CompanyActionsProps) => {
  const Wrapper = isUserActive ? React.Fragment : Tooltip;

  return (
    <>
      {user.hiring_teams && (
        <>
          <Tooltip title={!isUserActive ? 'You should confirm your email first' : 'Add team members'}>
            <Link
              to={isUserActive ? ROUTES.employer.preferences.hiring : ROUTES.employer.inactive}
              colors="cloudyBlueTwoToBlueGreyTwo"
            >
              <Box as={Plus} />
            </Link>
          </Tooltip>
          <Box mr={15} />
        </>
      )}
      <Wrapper title="You should confirm your email first">
        <Link to={isUserActive ? ROUTES.employer.jobs.new : ROUTES.employer.inactive}>
          <StyledButton type="button" px={15} variant="primary" size="sm">
            Post a job
          </StyledButton>
        </Link>
      </Wrapper>
      <Box mr={20} />
    </>
  );
};
